import type { AppVersion, VersionStatus } from "@/types";
import { compareVersionDesc } from "@/pages/app-detail/versions/platform";

/** 能改事件订阅的版本。已上线、审核中、待上线只读。 */
const EDITABLE_STATUSES = new Set<VersionStatus>(["developing", "rejected"]);

/**
 * 事件列表要看的版本。
 * 文档没有把列表限制在草稿 / 已拒绝；没有可编辑版本时回落到审核中、待上线、已上线，只读。
 * 同一状态取版本号最新的一条。
 */
const LIST_STATUSES: VersionStatus[] = [
  "developing",
  "rejected",
  "reviewing",
  "scheduled",
  "released",
];

export interface EventListVersion {
  id: string;
  editable: boolean;
}

function newest(versions: AppVersion[], status: VersionStatus): AppVersion | undefined {
  return versions
    .filter((version) => version.status === status)
    .sort((a, b) => compareVersionDesc(a.version, b.version))[0];
}

export function eventListVersion(versions: AppVersion[]): EventListVersion {
  for (const status of LIST_STATUSES) {
    const hit = newest(versions, status);
    if (hit) {
      return { id: hit.id, editable: EDITABLE_STATUSES.has(status) };
    }
  }
  return { id: "", editable: false };
}

/** 添加 / 删除只用可编辑版本；没有草稿或已拒绝时为空。 */
export function editableVersionId(versions: AppVersion[]): string {
  const target = eventListVersion(versions);
  return target.editable ? target.id : "";
}
